import { render } from "./GroupPublish.vue?vue&type=template&id=023298c5&scoped=true"
import script from "./GroupPublish.vue?vue&type=script&lang=js"
export * from "./GroupPublish.vue?vue&type=script&lang=js"

import "../../styles/van-sticky-nav.css?vue&type=style&index=0&lang=css"
import "./GroupPublish.vue?vue&type=style&index=1&id=023298c5&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-023298c5"]])

export default __exports__